/** Joins city and postcode into a display-ready address string. Returns an empty string when both are empty. */
export const formatAddress = (city?: string, postcode?: string) => {
  const formatted = [city, postcode].filter(Boolean).join(', ');

  return formatted || '';
};
